export default __webpack_public_path__ + "static/media/error.4b620928.svg";